var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbmIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152.5 134.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -817.47,
    y1: 12260.72,
    x2: -2960.56,
    y2: 15972.67,
    gradientTransform: "translate(138.15 -463.71) scale(0.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50ffd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.3,53.81a2.32,2.32,0,0,1-1.4-.4L5.3,45.51a2.94,2.94,0,0,1-1.4-3.6,2.81,2.81,0,0,1,3.57-1.75l.13.05c.2.1.3.1.5.2l13.6,7.9a3.09,3.09,0,0,1,1.3,3.9A3.28,3.28,0,0,1,20.3,53.81Zm23.5-23.5a3.09,3.09,0,0,1-2.5-1.4l-7.9-13.6a3.06,3.06,0,0,1,.6-3.8,3,3,0,0,1,4.1.3h0c.1.1.2.3.3.4l7.9,13.6a3,3,0,0,1-.8,4A3.3,3.3,0,0,1,43.8,30.31Zm29.3-11.7V3.11A3.13,3.13,0,0,1,75.9,0a2.91,2.91,0,0,1,3,2.8h0v16A2.9,2.9,0,0,1,76,21.7h-.1A3.13,3.13,0,0,1,73.1,18.61Zm35.1,11.7a2.78,2.78,0,0,1-1.6-.5,3.08,3.08,0,0,1-.8-4l7.9-13.6a2.85,2.85,0,0,1,3.87-1.11h0c.1.1.3.2.4.3a3.06,3.06,0,0,1,.6,3.8l-7.9,13.6A3.08,3.08,0,0,1,108.2,30.31Zm23.5,23.5a2.83,2.83,0,0,1-1.3-5.4l13.5-7.8a2.87,2.87,0,0,1,3.4,4.6h0c-.1.1-.3.2-.4.3l-13.8,8A3.1,3.1,0,0,1,131.7,53.81Zm-92.3,65.9a51.76,51.76,0,0,1,73.2-73.2,57.56,57.56,0,0,1,4.1,4.6c.9,1.1,1.7,2.3,2.5,3.5l-4.8,3.2a33.44,33.44,0,0,0-2.2-3.1,47.87,47.87,0,0,0-3.7-4.1,46,46,0,0,0-65.1,65.1Zm73.5,15.2H33.2A33.42,33.42,0,0,1,0,101.27v-.06H5.8a27.7,27.7,0,0,0,27.5,27.9h79.6a33.78,33.78,0,0,0,25.2-56.3l4.3-3.8a39.56,39.56,0,0,1-3.06,55.86l0,0A40.16,40.16,0,0,1,112.9,134.91ZM5.8,101.21H0a33.45,33.45,0,0,1,27.9-32.7l1,5.7A27.56,27.56,0,0,0,5.8,101.21Zm73.3-6.1H73.3a39.52,39.52,0,0,1,69-26.1l-4.3,3.8a33.82,33.82,0,0,0-47.7-2.7A34.34,34.34,0,0,0,79.1,95.11Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmIconNew);
export default __webpack_public_path__ + "static/media/IBM-icon-new.946b2385b0e00dc996d1b7b8190268ef.svg";
export { ForwardRef as ReactComponent };